import React from 'react';
import { Shield, Lock, Eye, Link as LinkIcon, Settings, FileText } from 'lucide-react';
export function PrivacyPolicyPage() {
  return <div className="bg-white min-h-screen pb-20" data-id="element-450">
      {/* Page Header */}
      <div className="bg-gray-50 border-b border-gray-200 py-16 px-4 sm:px-6 lg:px-8" data-id="element-451">
        <div className="max-w-4xl mx-auto text-center" data-id="element-452">
          <div className="flex items-center justify-center gap-3 mb-4" data-id="element-453">
            <Shield className="w-10 h-10 text-[#0e7be1]" data-id="element-454" />
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900" data-id="element-455">
              Privacy Policy
            </h1>
          </div>
          <div className="w-24 h-1 bg-[#0e7be1] mx-auto rounded-full mt-6" data-id="element-456"></div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12" data-id="element-457">
        {/* Intro */}
        <section className="prose prose-lg max-w-none text-gray-600" data-id="element-458">
          <p data-id="element-459">
            This privacy policy sets out how we use and protect any information
            that you give when you use this website. We are committed to
            ensuring that your privacy is protected. Should we ask you to
            provide certain information by which you can be identified when
            using this website, then you can be assured that it will only be
            used in accordance with this privacy statement. We may change this
            policy from time to time by updating this page. You should check
            this page from time to time to ensure that you are happy with any
            changes.
          </p>
        </section>

        {/* What we collect */}
        <section data-id="element-460">
          <div className="flex items-center gap-3 mb-4" data-id="element-461">
            <FileText className="w-6 h-6 text-[#0e7be1]" data-id="element-462" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-463">
              What we collect
            </h2>
          </div>
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100" data-id="element-464">
            <p className="mb-4 text-gray-700 font-medium" data-id="element-465">
              We may collect the following information:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-gray-600" data-id="element-466">
              <li data-id="element-467">Name</li>
              <li data-id="element-468">Contact information including email address</li>
              <li data-id="element-469">
                Demographic information such as postcode, preferences and
                interests
              </li>
              <li data-id="element-470">
                Other information relevant to customer surveys and/or offers
              </li>
            </ul>
          </div>
        </section>

        {/* What we do with information */}
        <section data-id="element-471">
          <div className="flex items-center gap-3 mb-4" data-id="element-472">
            <Settings className="w-6 h-6 text-[#0e7be1]" data-id="element-473" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-474">
              What we do with the information we gather
            </h2>
          </div>
          <div className="prose prose-lg max-w-none text-gray-600" data-id="element-475">
            <p className="mb-4" data-id="element-476">
              We require this information to understand your needs and provide
              you with a better service, and in particular for the following
              reasons:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-477">
              <li data-id="element-478">Internal record keeping.</li>
              <li data-id="element-479">
                We may use the information to improve our products and services.
              </li>
              <li data-id="element-480">
                We may periodically send promotional emails about new products,
                special offers or other information which we think you may find
                interesting using the email address which you have provided.
              </li>
              <li data-id="element-481">
                From time to time, we may also use your information to contact
                you for market research purposes. We may contact you by email,
                phone, fax or mail. We may use the information to customise the
                website according to your interests.
              </li>
            </ul>
          </div>
        </section>

        {/* Security */}
        <section data-id="element-482">
          <div className="flex items-center gap-3 mb-4" data-id="element-483">
            <Lock className="w-6 h-6 text-[#0e7be1]" data-id="element-484" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-485">Security</h2>
          </div>
          <div className="prose prose-lg max-w-none text-gray-600" data-id="element-486">
            <p data-id="element-487">
              We are committed to ensuring that your information is secure. In
              order to prevent unauthorised access or disclosure, we have put in
              place suitable physical, electronic and managerial procedures to
              safeguard and secure the information we collect online.
            </p>
          </div>
        </section>

        {/* Cookies */}
        <section data-id="element-488">
          <div className="flex items-center gap-3 mb-4" data-id="element-489">
            <Eye className="w-6 h-6 text-[#0e7be1]" data-id="element-490" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-491">
              How we use cookies
            </h2>
          </div>
          <div className="prose prose-lg max-w-none text-gray-600 space-y-4" data-id="element-492">
            <p data-id="element-493">
              A cookie is a small file which asks permission to be placed on
              your computer's hard drive. Once you agree, the file is added and
              the cookie helps analyse web traffic or lets you know when you
              visit a particular site. Cookies allow web applications to respond
              to you as an individual. The web application can tailor its
              operations to your needs, likes and dislikes by gathering and
              remembering information about your preferences.
            </p>
            <p data-id="element-494">
              We use traffic log cookies to identify which pages are being used.
              This helps us analyse data about web page traffic and improve our
              website in order to tailor it to customer needs. We only use this
              information for statistical analysis purposes and then the data is
              removed from the system.
            </p>
            <p data-id="element-495">
              Overall, cookies help us provide you with a better website, by
              enabling us to monitor which pages you find useful and which you
              do not. A cookie in no way gives us access to your computer or any
              information about you, other than the data you choose to share
              with us. You can choose to accept or decline cookies. Most web
              browsers automatically accept cookies, but you can usually modify
              your browser setting to decline cookies if you prefer. This may
              prevent you from taking full advantage of the website.
            </p>
          </div>
        </section>

        {/* Links */}
        <section data-id="element-496">
          <div className="flex items-center gap-3 mb-4" data-id="element-497">
            <LinkIcon className="w-6 h-6 text-[#0e7be1]" data-id="element-498" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-499">
              Links to other websites
            </h2>
          </div>
          <div className="bg-blue-50 rounded-xl p-6 border border-blue-100" data-id="element-500">
            <p className="text-gray-700 leading-relaxed" data-id="element-501">
              Our website may contain links to other websites of interest.
              However, once you have used these links to leave our site, you
              should note that we do not have any control over that other
              website. Therefore, we cannot be responsible for the protection
              and privacy of any information which you provide whilst visiting
              such sites and such sites are not governed by this privacy
              statement. You should exercise caution and look at the privacy
              statement applicable to the website in question.
            </p>
          </div>
        </section>

        {/* Controlling Info */}
        <section data-id="element-502">
          <div className="flex items-center gap-3 mb-4" data-id="element-503">
            <Shield className="w-6 h-6 text-[#0e7be1]" data-id="element-504" />
            <h2 className="text-2xl font-bold text-gray-900" data-id="element-505">
              Controlling your personal information
            </h2>
          </div>
          <div className="prose prose-lg max-w-none text-gray-600 space-y-4" data-id="element-506">
            <p data-id="element-507">
              You may choose to restrict the collection or use of your personal
              information in the following ways:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-508">
              <li data-id="element-509">
                Whenever you are asked to fill in a form on the website, look
                for the box that you can click to indicate that you do not want
                the information to be used by anybody for direct marketing
                purposes.
              </li>
              <li data-id="element-510">
                If you have previously agreed to us using your personal
                information for direct marketing purposes, you may change your
                mind at any time by writing to or emailing us at{' '}
                <a href="mailto:sales@lookfeelbetter.com" className="text-[#0e7be1] hover:underline" data-id="element-511">
                  sales@lookfeelbetter.com
                </a>
              </li>
            </ul>
            <p data-id="element-512">
              We will not sell, distribute or lease your personal information to
              third parties unless we have your permission or are required by
              law to do so. We may use your personal information to send you
              promotional information about third parties which we think you may
              find interesting if you tell us that you wish this to happen.
            </p>
            <p data-id="element-513">
              You may request details of personal information which we hold
              about you under the Data Protection Act 1998. A small fee will be
              payable. If you would like a copy of the information held on you
              please write to us. If you believe that any information we are
              holding on you is incorrect or incomplete, please write to or
              email us as soon as possible. We will promptly correct any
              information found to be incorrect.
            </p>
          </div>
        </section>
      </div>
    </div>;
}